var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgServerError(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 248.43 188.32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{clip-path:url(#clip-path);}.cls-3{fill:#656565;}.cls-4{clip-path:url(#clip-path-2);}.cls-5{clip-path:url(#clip-path-3);}.cls-6{fill:#fff;}.cls-7{fill:#ea5b27;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M138.4,155.66l-8.51,4.92a5.34,5.34,0,0,1-4.77-.2l-11.27-6.51c-1.41-.81-1.56-2.05-.34-2.75l8.5-4.91a5.3,5.3,0,0,1,4.77.19l11.27,6.51C139.47,153.73,139.62,155,138.4,155.66Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M75,118.32l-8.5,4.91a5.34,5.34,0,0,1-4.77-.2l-11.27-6.51c-1.41-.81-1.57-2-.35-2.75l8.51-4.91a5.27,5.27,0,0,1,4.77.2l11.27,6.5C76.09,116.38,76.24,117.61,75,118.32Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M194,123.1l-8.5,4.91a5.3,5.3,0,0,1-4.77-.19l-11.27-6.51c-1.41-.82-1.56-2-.34-2.75l8.5-4.92a5.34,5.34,0,0,1,4.77.2l11.27,6.51C195.11,121.16,195.27,122.4,194,123.1Z"
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icono") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "content"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 88.16,
    y: 149.11,
    width: 75.72,
    height: 0.82,
    transform: "translate(-57.83 82.92) rotate(-29.96)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 90.38,
    y: 150.29,
    width: 75.71,
    height: 0.82,
    transform: "translate(-58.13 84.21) rotate(-29.97)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 92.39,
    y: 151.55,
    width: 75.72,
    height: 0.82,
    transform: "translate(-58.5 85.4) rotate(-29.98)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 94.66,
    y: 152.71,
    width: 75.71,
    height: 0.82,
    transform: "translate(-58.77 86.66) rotate(-29.97)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 96.52,
    y: 154.01,
    width: 75.72,
    height: 0.82,
    transform: "translate(-59.18 87.79) rotate(-29.98)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 98.74,
    y: 155.19,
    width: 75.71,
    height: 0.82,
    transform: "translate(-59.45 89.02) rotate(-29.96)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 100.75,
    y: 156.45,
    width: 75.72,
    height: 0.82,
    transform: "translate(-59.82 90.22) rotate(-29.97)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 103.02,
    y: 157.61,
    width: 75.71,
    height: 0.82,
    transform: "translate(-60.09 91.48) rotate(-29.96)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 105.03,
    y: 158.87,
    width: 75.71,
    height: 0.82,
    transform: "translate(-60.46 92.68) rotate(-29.97)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 107.29,
    y: 160.05,
    width: 75.72,
    height: 0.82,
    transform: "translate(-60.75 93.95) rotate(-29.97)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 109.3,
    y: 161.31,
    width: 75.71,
    height: 0.82,
    transform: "translate(-61.11 95.14) rotate(-29.97)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 111.56,
    y: 162.47,
    width: 75.71,
    height: 0.82,
    transform: "translate(-61.39 96.42) rotate(-29.97)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 113.43,
    y: 163.77,
    width: 75.71,
    height: 0.82,
    transform: "translate(-61.79 97.53) rotate(-29.97)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 115.65,
    y: 164.95,
    width: 75.72,
    height: 0.82,
    transform: "translate(-62.08 98.79) rotate(-29.97)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 117.66,
    y: 166.21,
    width: 75.71,
    height: 0.82,
    transform: "translate(-62.44 99.97) rotate(-29.97)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 119.92,
    y: 167.37,
    width: 75.71,
    height: 0.82,
    transform: "translate(-62.72 101.25) rotate(-29.97)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 121.93,
    y: 168.63,
    width: 75.72,
    height: 0.82,
    transform: "translate(-63.07 102.4) rotate(-29.96)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 58.5,
    y: 132.1,
    width: 75.72,
    height: 0.82,
    transform: "translate(-53.3 65.83) rotate(-29.96)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 60.77,
    y: 133.25,
    width: 75.71,
    height: 0.82,
    transform: "translate(-53.58 67.14) rotate(-29.97)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 62.63,
    y: 134.55,
    width: 75.71,
    height: 0.82,
    transform: "translate(-53.98 68.25) rotate(-29.97)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 64.85,
    y: 135.74,
    width: 75.72,
    height: 0.82,
    transform: "translate(-54.28 69.51) rotate(-29.97)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 66.87,
    y: 137,
    width: 75.71,
    height: 0.82,
    transform: "translate(-54.63 70.68) rotate(-29.97)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 69.13,
    y: 138.15,
    width: 75.71,
    height: 0.82,
    transform: "translate(-54.92 71.99) rotate(-29.98)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 71.14,
    y: 139.42,
    width: 75.72,
    height: 0.82,
    transform: "translate(-55.26 73.12) rotate(-29.96)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 73.4,
    y: 140.59,
    width: 75.72,
    height: 0.82,
    transform: "translate(-55.55 74.41) rotate(-29.96)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 75.41,
    y: 141.86,
    width: 75.71,
    height: 0.82,
    transform: "translate(-55.92 75.59) rotate(-29.97)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 77.67,
    y: 143.01,
    width: 75.72,
    height: 0.82,
    transform: "translate(-56.19 76.88) rotate(-29.97)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 79.54,
    y: 144.31,
    width: 75.71,
    height: 0.82,
    transform: "translate(-56.59 77.97) rotate(-29.96)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 81.76,
    y: 145.5,
    width: 75.71,
    height: 0.82,
    transform: "translate(-56.9 79.28) rotate(-29.98)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 83.77,
    y: 146.76,
    width: 75.71,
    height: 0.82,
    transform: "translate(-57.25 80.44) rotate(-29.97)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 86.03,
    y: 147.92,
    width: 75.72,
    height: 0.82,
    transform: "translate(-57.52 81.7) rotate(-29.96)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 88.05,
    y: 149.18,
    width: 75.71,
    height: 0.82,
    transform: "translate(-57.89 82.9) rotate(-29.97)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 24.79,
    y: 111.76,
    width: 75.72,
    height: 0.82,
    transform: "translate(-47.66 46.29) rotate(-29.97)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 27.01,
    y: 112.94,
    width: 75.71,
    height: 0.82,
    transform: "translate(-47.94 47.54) rotate(-29.96)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 29.02,
    y: 114.2,
    width: 75.72,
    height: 0.82,
    transform: "translate(-48.3 48.72) rotate(-29.96)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 31.28,
    y: 115.36,
    width: 75.72,
    height: 0.82,
    transform: "translate(-48.59 50.02) rotate(-29.97)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 33.15,
    y: 116.66,
    width: 75.72,
    height: 0.82,
    transform: "translate(-48.99 51.12) rotate(-29.97)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 35.37,
    y: 117.84,
    width: 75.71,
    height: 0.82,
    transform: "translate(-49.27 52.37) rotate(-29.96)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 37.38,
    y: 119.1,
    width: 75.72,
    height: 0.82,
    transform: "translate(-49.64 53.56) rotate(-29.97)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 39.64,
    y: 120.26,
    width: 75.72,
    height: 0.82,
    transform: "translate(-49.92 54.86) rotate(-29.98)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 41.66,
    y: 121.52,
    width: 75.71,
    height: 0.82,
    transform: "translate(-50.27 56.01) rotate(-29.96)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 43.91,
    y: 122.7,
    width: 75.72,
    height: 0.82,
    transform: "translate(-50.57 57.31) rotate(-29.97)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 45.92,
    y: 123.96,
    width: 75.72,
    height: 0.82,
    transform: "translate(-50.92 58.48) rotate(-29.97)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 48.19,
    y: 125.12,
    width: 75.71,
    height: 0.82,
    transform: "translate(-51.21 59.78) rotate(-29.98)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 50.05,
    y: 126.42,
    width: 75.72,
    height: 0.82,
    transform: "translate(-51.59 60.85) rotate(-29.96)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 52.27,
    y: 127.6,
    width: 75.72,
    height: 0.82,
    transform: "translate(-51.9 62.15) rotate(-29.98)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 54.28,
    y: 128.86,
    width: 75.72,
    height: 0.82,
    transform: "translate(-52.25 63.29) rotate(-29.96)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 56.55,
    y: 130.02,
    width: 75.71,
    height: 0.82,
    transform: "translate(-52.52 64.58) rotate(-29.96)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 58.56,
    y: 131.28,
    width: 75.72,
    height: 0.82,
    transform: "translate(-52.89 65.77) rotate(-29.97)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: -4.87,
    y: 94.75,
    width: 75.72,
    height: 0.82,
    transform: "translate(-43.11 29.19) rotate(-29.96)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: -2.61,
    y: 95.91,
    width: 75.71,
    height: 0.82,
    transform: "translate(-43.39 30.48) rotate(-29.96)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: -0.74,
    y: 97.2,
    width: 75.72,
    height: 0.82,
    transform: "translate(-43.79 31.58) rotate(-29.96)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 1.48,
    y: 98.39,
    width: 75.72,
    height: 0.82,
    transform: "translate(-44.08 32.85) rotate(-29.96)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 3.49,
    y: 99.65,
    width: 75.72,
    height: 0.82,
    transform: "translate(-44.45 34.03) rotate(-29.97)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 5.75,
    y: 100.81,
    width: 75.71,
    height: 0.82,
    transform: "translate(-44.72 35.31) rotate(-29.96)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 7.77,
    y: 102.07,
    width: 75.72,
    height: 0.82,
    transform: "translate(-45.09 36.49) rotate(-29.97)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 10.02,
    y: 103.25,
    width: 75.72,
    height: 0.82,
    transform: "translate(-45.37 37.76) rotate(-29.96)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 12.03,
    y: 104.51,
    width: 75.71,
    height: 0.82,
    transform: "translate(-45.74 38.95) rotate(-29.97)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 14.3,
    y: 105.66,
    width: 75.72,
    height: 0.82,
    transform: "translate(-46.01 40.24) rotate(-29.97)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 16.16,
    y: 106.96,
    width: 75.71,
    height: 0.82,
    transform: "translate(-46.41 41.34) rotate(-29.97)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 18.38,
    y: 108.15,
    width: 75.72,
    height: 0.82,
    transform: "translate(-46.7 42.59) rotate(-29.96)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 20.39,
    y: 109.41,
    width: 75.71,
    height: 0.82,
    transform: "translate(-47.07 43.79) rotate(-29.98)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 22.66,
    y: 110.57,
    width: 75.72,
    height: 0.82,
    transform: "translate(-47.35 45.08) rotate(-29.98)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 24.67,
    y: 111.83,
    width: 75.72,
    height: 0.82,
    transform: "translate(-47.7 46.23) rotate(-29.96)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 143.81,
    y: 116.55,
    width: 75.71,
    height: 0.82,
    transform: "translate(-34.13 106.38) rotate(-29.97)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 146.03,
    y: 117.73,
    width: 75.72,
    height: 0.82,
    transform: "translate(-34.43 107.64) rotate(-29.97)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 148.04,
    y: 118.99,
    width: 75.72,
    height: 0.82,
    transform: "translate(-34.79 108.83) rotate(-29.97)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 150.31,
    y: 120.15,
    width: 75.71,
    height: 0.82,
    transform: "translate(-35.06 110.08) rotate(-29.96)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 152.17,
    y: 121.45,
    width: 75.71,
    height: 0.82,
    transform: "translate(-35.46 111.19) rotate(-29.96)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 154.39,
    y: 122.63,
    width: 75.72,
    height: 0.82,
    transform: "translate(-35.76 112.46) rotate(-29.96)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 156.4,
    y: 123.89,
    width: 75.71,
    height: 0.82,
    transform: "translate(-36.12 113.68) rotate(-29.98)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 158.67,
    y: 125.05,
    width: 75.71,
    height: 0.82,
    transform: "translate(-36.39 114.91) rotate(-29.96)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 160.68,
    y: 126.31,
    width: 75.72,
    height: 0.82,
    transform: "translate(-36.75 116.09) rotate(-29.96)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 162.93,
    y: 127.49,
    width: 75.72,
    height: 0.82,
    transform: "translate(-37.04 117.41) rotate(-29.97)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 164.95,
    y: 128.75,
    width: 75.71,
    height: 0.82,
    transform: "translate(-37.4 118.57) rotate(-29.97)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 167.21,
    y: 129.91,
    width: 75.72,
    height: 0.82,
    transform: "translate(-37.68 119.87) rotate(-29.97)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 169.08,
    y: 131.21,
    width: 75.71,
    height: 0.82,
    transform: "translate(-38.08 120.94) rotate(-29.96)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 171.29,
    y: 132.39,
    width: 75.72,
    height: 0.82,
    transform: "translate(-38.37 122.24) rotate(-29.97)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 173.31,
    y: 133.65,
    width: 75.71,
    height: 0.82,
    transform: "translate(-38.73 123.38) rotate(-29.96)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 175.57,
    y: 134.81,
    width: 75.72,
    height: 0.82,
    transform: "translate(-39.01 124.72) rotate(-29.98)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 177.58,
    y: 136.07,
    width: 75.72,
    height: 0.82,
    transform: "translate(-39.37 125.87) rotate(-29.97)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 114.15,
    y: 99.53,
    width: 75.71,
    height: 0.82,
    transform: "translate(-29.6 89.28) rotate(-29.96)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 116.41,
    y: 100.69,
    width: 75.72,
    height: 0.82,
    transform: "translate(-29.87 90.57) rotate(-29.97)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 118.28,
    y: 101.99,
    width: 75.71,
    height: 0.82,
    transform: "translate(-30.27 91.68) rotate(-29.97)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 120.5,
    y: 103.17,
    width: 75.72,
    height: 0.82,
    transform: "translate(-30.57 92.96) rotate(-29.97)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 122.51,
    y: 104.43,
    width: 75.71,
    height: 0.82,
    transform: "translate(-30.93 94.1) rotate(-29.96)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 124.78,
    y: 105.59,
    width: 75.72,
    height: 0.82,
    transform: "translate(-31.2 95.39) rotate(-29.96)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 126.79,
    y: 106.85,
    width: 75.71,
    height: 0.82,
    transform: "translate(-31.57 96.56) rotate(-29.96)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 129.04,
    y: 108.03,
    width: 75.71,
    height: 0.82,
    transform: "translate(-31.85 97.85) rotate(-29.96)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 131.06,
    y: 109.29,
    width: 75.71,
    height: 0.82,
    transform: "translate(-32.22 99.05) rotate(-29.97)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 133.32,
    y: 110.45,
    width: 75.72,
    height: 0.82,
    transform: "translate(-32.49 100.31) rotate(-29.96)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 135.19,
    y: 111.75,
    width: 75.72,
    height: 0.82,
    transform: "translate(-32.89 101.44) rotate(-29.97)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 137.41,
    y: 112.93,
    width: 75.71,
    height: 0.82,
    transform: "translate(-33.18 102.68) rotate(-29.96)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 139.42,
    y: 114.19,
    width: 75.72,
    height: 0.82,
    transform: "translate(-33.55 103.88) rotate(-29.97)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 141.68,
    y: 115.35,
    width: 75.72,
    height: 0.82,
    transform: "translate(-33.82 105.17) rotate(-29.97)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 143.69,
    y: 116.61,
    width: 75.71,
    height: 0.82,
    transform: "translate(-34.18 106.34) rotate(-29.97)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M120.26,85.18,93.41,32h0L66.52,116.23h0l-3.25,1.9s0,0,0,0L93.38,23.61h0l30.15,59.7v0l-3.27,1.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M63.2,119l-.78-.6.14-.48,30.3-95,1-.07.22.41,30.45,60.3-.57.35-3.57,2-.6-.21-.12-.26L93.54,33.84,67.12,116.68l-.22.15ZM93.54,25.44,64.46,116.62l1.47-.85L92.86,31.33l1-.06.22.42,26.52,52.52L122.63,83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M54.45,113l8.76,5.16s0,0,0,0L93.39,23.59h0l-8.76-5.17a0,0,0,0,0,0,0L54.45,113Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M63.16,118.92l-.3-.16-9.25-5.5.17-.52L84,17.87l.66-.25.32.2,9.25,5.46-.22.57L63.8,118.68Zm-7.87-6.27,7.53,4.45L92.55,23.9,85,19.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M111.49,80l8.74,5.16s0,0,0,0L93.41,32h0L91,39.46h0L111.48,80Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M120.33,86l-.46-.26L111,80.54l-.11-.22-20.6-40.8,2.61-8.19,1-.06.22.42,27.08,53.63ZM112,79.51l6.53,3.85-25-49.52-1.78,5.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M175.21,117.13l8.68,5.12a0,0,0,0,0,.05,0l-26.79-53a0,0,0,0,0-.06,0l-2.36,7.39v0l20.47,40.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M184,123.13l-.5-.27-8.91-5.32L154,76.52l.05-.17,2.51-7.86,1-.08.24.45,27,53.5Zm-8.29-6.51,6.53,3.86L157.26,71l-1.77,5.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M103.93,65.66,174.25,108h0l1.67-1s0,0,0,0l-3.06-6.06h0L101,59.91h0l-1.69,1,4.59,4.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M174.29,108.78l-.35-.17L103.49,66.22l-.07-.07-5.23-5.43,2.8-1.61.35.17,72.08,41.15,3.48,6.88-.64.34ZM104.37,65.1l69.9,42.06.75-.43-2.67-5.28L101,60.72l-.56.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M102.24,66.63l72,41.33s0,0,0,0l-3-6h0l-71.82-41s0,0,0,0l2.88,5.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M174.36,108.83l-.48-.25L101.71,67.15l-3.24-6.4.8-.72.46.27,72,41.1,3.37,6.68ZM102.77,66.12l69.8,40.08-1.91-3.78L101,62.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M118.18,150.09l8.75,5.17h0L157.11,60.7h0l-8.76-5.17h0l-30.16,94.54S118.17,150.09,118.18,150.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M126.86,156.05l-.32-.2-9.24-5.47.21-.57L147.76,55l.66-.26.32.2L158,60.39l-.22.58-30.25,94.82ZM119,149.76l7.54,4.45L156.27,61l-7.53-4.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M184,122.27,157.16,69.19s-.07,0-.08,0l-26.84,84.15,0,0-3.17,1.85a0,0,0,0,1-.07-.05l30.1-94.36s.07,0,.08,0l30.1,59.61s0,0,0,0L184,122.29A0,0,0,0,1,184,122.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M127,156.06l-.8-.61.13-.5,30.25-94.82,1-.1.25.44,30.4,60.2-.59.39-3.48,2-.61-.15-.17-.3L157.26,71l-26.38,82.71-.16.21-.14.1Zm30.28-93.51-29.08,91.18,1.47-.85,26.91-84.36,1-.1.25.46,26.48,52.45,2.07-1.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M59.64,96.41l70.71,43.15h0l1.76-.86h0l1.55-5s0,0,0,0L61.23,91.42h0l-1.77.86h0l.18,4.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M130.29,140.39l-.36-.26L59,96.85l0-.36-.21-4.65,2.53-1.21.33.18,73,42.52-.22.58-1.6,5.24-.22.15ZM60.32,96l70.08,42.76,1.15-.56,1.3-4.23L61.19,92.22l-1,.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M57.86,97.28l72.49,42.28h0l1.55-5h0L59.46,92.29h0l-1.58,5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M130.31,140.35l-.32-.18L57.55,97.91,57,97.7l.14-.61,1.7-5.33.66-.25.3.18,73,42.5-.22.58-1.62,5.3ZM58.7,97,130,138.51l1.12-3.68L59.85,93.33Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "132.53 138.83 131.75 138.57 133.3 134.01 134.07 134.28 132.53 138.83"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 173.6,
    y: 100.68,
    width: 0.81,
    height: 4.98,
    transform: "translate(-27.82 89.51) rotate(-26.79)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 94.87,
    y: 29.47,
    width: 1.09,
    height: 8.48,
    transform: "matrix(0.5, -0.86, 0.86, 0.5, 18.23, 99.15)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M64.06,84.07l72.44,42.2h0L144,102.67s0,0,0,0L71.35,60.9h0l-1.47.41h0l-5.8,22.74S64.06,84.07,64.06,84.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M136.44,127l-.29-.16L63.67,84.66l-.43-.29.14-.52,5.9-23.11,2.18-.61.28.18,73.06,42-.09.51-7.63,24ZM64.87,83.72l71.24,41.51L143.17,103,71.25,61.66l-.8.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M62.58,84.49,135,126.69h0l7.5-23.59s0,0,0,0L69.88,61.32h0L62.58,84.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M134.94,127.47l-.31-.2L62.26,85.11l-.53-.23.17-.61,7.39-23.48.67-.26.31.2,73.14,42-.22.58-7.58,23.87ZM63.42,84.15l71.21,41.49,7.06-22.23-71.42-41Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "69.78 88.68 98.72 77.9 111.38 85.17 81.83 95.7 69.78 88.68"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M81.76,96.48,68.14,88.54,98.79,77.12l14.27,8.2ZM71.43,88.82l10.48,6.11L109.7,85l-11-6.34Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "93.22 102.2 122.16 91.42 134.82 98.7 105.27 109.22 93.22 102.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M105.2,110l-13.62-7.94,30.65-11.42,14.27,8.21Zm-10.33-7.66,10.48,6.11,27.79-9.9-11-6.35Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "116.66 115.73 141.46 106.49 137.26 119.7 128.71 122.75 116.66 115.73"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M128.64,123.52,115,115.59l27.55-10.27-4.75,14.93Zm-10.34-7.65,10.48,6.1,7.91-2.81,3.65-11.5Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "68.05 67.07 75.28 64.38 87.94 71.65 63.92 80.21 68.05 67.07"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M62.82,81.35l4.66-14.82,7.87-2.93,14.28,8.2Zm5.8-13.74L65,79.07,86.27,71.5l-11-6.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M74.43,50.19l72.44,42.2s0,0,0,0l7.5-23.59s0,0,0,0L81.72,27h0l-1.47.41a0,0,0,0,1,0,0l-5.8,22.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M146.79,93.18l-.31-.2L74,50.75l-.36-.26.09-.45,5.91-23.18,2.2-.61.29.21,73.12,42-.22.58-7.58,23.87ZM75.24,49.84l71.24,41.5,7.06-22.23L81.62,27.78l-.8.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M73,50.6,145.4,92.8s0,0,0,0l7.5-23.6a0,0,0,0,0,0,0L80.25,27.44h0L73,50.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M145.31,93.59l-.3-.2L72.62,51.22,72.13,51l.14-.56L79.66,26.9l.62-.23.29.14,73.12,42-.09.51-7.62,24ZM73.79,50.27,145,91.76l7.07-22.24-71.43-41Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "80.16 54.8 109.09 44.02 121.76 51.29 92.21 61.82 80.16 54.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M92.14,62.59,78.51,54.66l30.65-11.42,14.28,8.2ZM81.8,54.94,92.28,61l27.8-9.9-11-6.35Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "103.59 68.32 132.53 57.54 145.19 64.81 115.65 75.34 103.59 68.32"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M115.57,76.12,102,68.18,132.6,56.76,146.87,65Zm-10.33-7.66,10.48,6.11,27.8-9.91-11.05-6.34Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "127.03 81.84 151.83 72.61 147.63 85.82 139.09 88.86 127.03 81.84"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M139,89.64,125.39,81.7l27.55-10.26L148.2,86.37ZM128.68,82l10.48,6.1,7.9-2.82,3.66-11.5Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "78.43 33.19 85.66 30.49 98.32 37.77 74.29 46.33 78.43 33.19"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M73.19,47.47l4.67-14.82,7.86-2.93L100,37.92ZM79,33.73,75.39,45.19l21.25-7.57-11-6.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M126.45,99.9,86.53,90.21a3.08,3.08,0,0,1-2.18-3.36l3-24a2.39,2.39,0,0,1,2.89-2.19L130.45,70a3.1,3.1,0,0,1,2.24,3.43l-3.27,24.32A2.42,2.42,0,0,1,126.45,99.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M127,100.68a2.82,2.82,0,0,1-.75-.1L86.37,90.9a3.82,3.82,0,0,1-2.72-4.14l3-24A3.29,3.29,0,0,1,88,60.43,3,3,0,0,1,90.38,60l40.23,9.33a3.83,3.83,0,0,1,2.78,4.21l-3.27,24.32a3.33,3.33,0,0,1-1.38,2.32A3,3,0,0,1,127,100.68Zm-.42-1.47a1.59,1.59,0,0,0,1.33-.23,1.84,1.84,0,0,0,.78-1.33L132,73.33a2.38,2.38,0,0,0-1.7-2.65L90.07,61.35a1.55,1.55,0,0,0-1.26.23A1.89,1.89,0,0,0,88,62.94l-3,24a2.38,2.38,0,0,0,1.65,2.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M98.37,71l-.57,4.52a2.91,2.91,0,0,1-1,2.09,2.75,2.75,0,0,1-2.31.29,3.3,3.3,0,0,1-2-1.3,3.41,3.41,0,0,1-.47-2.42l.57-4.56,1.86.44-.55,4.4a2,2,0,0,0,.13,1.21,1.08,1.08,0,0,0,.75.55.87.87,0,0,0,.87-.16A1.9,1.9,0,0,0,96,75l.55-4.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M105.43,80.42,103,79.84,101.14,74h0c0,.85-.1,1.49-.16,1.93l-.43,3.37-1.65-.39,1-7.5,2.43.58,1.85,5.81h0c.05-.76.1-1.38.16-1.83l.44-3.4,1.67.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M113.32,78.25A3.7,3.7,0,0,1,112,80.93a3.31,3.31,0,0,1-2.82.38l-2.24-.53,1-7.52,2.4.57a4,4,0,0,1,2.47,1.53A4.06,4.06,0,0,1,113.32,78.25Zm-2-.38a2.73,2.73,0,0,0-.18-1.63,1.56,1.56,0,0,0-1.08-.77l-.55-.13L109,79.56l.42.1a1.38,1.38,0,0,0,1.32-.24A2.63,2.63,0,0,0,111.36,77.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M118.19,83.45l-4.14-1,1-7.53,4.14,1L119,77.55,116.71,77l-.16,1.18,2.09.5-.21,1.63-2.09-.49-.19,1.42,2.26.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M121.66,81.45l-.36,2.74-1.89-.45,1-7.54,2.3.54c1.9.45,2.76,1.41,2.56,2.9a2,2,0,0,1-1.46,1.75l1.6,3.78-2.14-.51-1.12-3.1Zm.2-1.54.36.09c.66.15,1-.08,1.11-.71s-.22-.86-.87-1l-.37-.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M92.15,80.43a.45.45,0,0,0-.49.15,1.22,1.22,0,0,0-.26.68c-.08.64.1,1,.55,1.12a1.35,1.35,0,0,0,.4,0l.4,0-.1.75a1.88,1.88,0,0,1-.88,0,1.49,1.49,0,0,1-1-.69,2.41,2.41,0,0,1,.08-2.21,1.13,1.13,0,0,1,.59-.47,1.38,1.38,0,0,1,.81,0,2.24,2.24,0,0,1,.91.46l-.34.65a2.35,2.35,0,0,0-.32-.23A1.35,1.35,0,0,0,92.15,80.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M96.29,82.41a1.73,1.73,0,0,1-.54,1.19,1.31,1.31,0,0,1-1.16.17,1.59,1.59,0,0,1-1-.7,2,2,0,0,1-.22-1.37,1.67,1.67,0,0,1,.54-1.18A1.31,1.31,0,0,1,95,80.35a1.64,1.64,0,0,1,1,.7A2.09,2.09,0,0,1,96.29,82.41Zm-2.1-.5c-.08.64.08,1,.49,1.11a.48.48,0,0,0,.5-.12,1.25,1.25,0,0,0,.24-.69,1.55,1.55,0,0,0-.06-.78.58.58,0,0,0-.43-.34C94.52,81,94.27,81.26,94.19,81.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M99.54,84.91l-1.09-.26L97.64,82h0c0,.38-.05.66-.07.86l-.19,1.49-.73-.17.42-3.32,1.08.26L99,83.72h0c0-.34.05-.61.07-.81l.2-1.5.73.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M102.33,84.53a1.06,1.06,0,0,1-.21.52.83.83,0,0,1-.47.27,1.36,1.36,0,0,1-.66,0,2.23,2.23,0,0,1-.5-.17,1.87,1.87,0,0,1-.41-.26l.1-.8a3,3,0,0,0,.47.32,2.08,2.08,0,0,0,.45.19.42.42,0,0,0,.28,0,.18.18,0,0,0,.11-.16.17.17,0,0,0,0-.12.51.51,0,0,0-.09-.13l-.38-.32a2,2,0,0,1-.42-.39,1,1,0,0,1-.18-.37,1.27,1.27,0,0,1,0-.44.83.83,0,0,1,.4-.65,1.22,1.22,0,0,1,.88,0,2.38,2.38,0,0,1,.94.47l-.34.63a2,2,0,0,0-.71-.39.4.4,0,0,0-.25,0,.18.18,0,0,0-.09.13.27.27,0,0,0,.07.2,3.81,3.81,0,0,0,.47.4,1.75,1.75,0,0,1,.5.55A1,1,0,0,1,102.33,84.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M104,86l-.83-.2.33-2.59-.75-.18.1-.73,2.32.55-.09.74-.75-.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M106.2,85.25,106,86.47l-.83-.2.43-3.33,1,.24c.83.2,1.21.62,1.13,1.28a.89.89,0,0,1-.64.77l.71,1.67-.95-.23-.49-1.37Zm.09-.67.15,0c.29.07.45,0,.49-.31s-.1-.38-.38-.44l-.17,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M111.18,84.26l-.26,2a1.32,1.32,0,0,1-.48.94,1.25,1.25,0,0,1-1,.12,1.48,1.48,0,0,1-.92-.58,1.5,1.5,0,0,1-.21-1.09l.26-2,.84.2-.26,2a.92.92,0,0,0,.06.55.51.51,0,0,0,.34.24.39.39,0,0,0,.39-.07.84.84,0,0,0,.18-.49l.25-2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M113.11,85.43a.47.47,0,0,0-.5.15,1.3,1.3,0,0,0-.26.69c-.08.64.1,1,.55,1.13a1.42,1.42,0,0,0,.41,0l.4-.06-.1.77a2,2,0,0,1-.9,0,1.53,1.53,0,0,1-1-.69,2.1,2.1,0,0,1-.21-1.36,2.24,2.24,0,0,1,.3-.87,1.26,1.26,0,0,1,.6-.48,1.51,1.51,0,0,1,.82,0,2.28,2.28,0,0,1,.93.47l-.35.65a1.72,1.72,0,0,0-.32-.23A1.14,1.14,0,0,0,113.11,85.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M115.56,88.75l-.84-.2.35-2.61-.76-.18.1-.73,2.34.56-.1.73-.75-.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M116.75,89l.44-3.34.85.2-.44,3.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M121.39,88.41a1.72,1.72,0,0,1-.56,1.19,1.29,1.29,0,0,1-1.18.17,1.63,1.63,0,0,1-1.06-.7,2.09,2.09,0,0,1-.22-1.38,1.76,1.76,0,0,1,.56-1.19,1.36,1.36,0,0,1,1.18-.17,1.65,1.65,0,0,1,1.07.71A2.12,2.12,0,0,1,121.39,88.41Zm-2.14-.51c-.08.65.08,1,.5,1.12a.48.48,0,0,0,.5-.12,1.28,1.28,0,0,0,.26-.7,1.57,1.57,0,0,0-.06-.78.63.63,0,0,0-.44-.35C119.59,87,119.34,87.25,119.25,87.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M124.69,90.93l-1.1-.26L122.76,88h0c0,.37,0,.66-.07.85l-.2,1.51-.74-.18.44-3.34,1.1.26.82,2.6h0c0-.34.06-.62.08-.82l.2-1.51.75.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M91.88,65.3a.93.93,0,0,1-1.12.85,1.19,1.19,0,0,1-.85-1.31A.92.92,0,0,1,91,64,1.19,1.19,0,0,1,91.88,65.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M129.47,74.07a1,1,0,0,1-1.16.86,1.21,1.21,0,0,1-.87-1.33,1,1,0,0,1,1.16-.86A1.21,1.21,0,0,1,129.47,74.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M89.17,87a.92.92,0,0,1-1.12.83,1.2,1.2,0,0,1-.85-1.3.93.93,0,0,1,1.12-.84A1.21,1.21,0,0,1,89.17,87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M126.53,96a.93.93,0,0,1-1.15.83,1.2,1.2,0,0,1-.86-1.32.94.94,0,0,1,1.15-.84A1.2,1.2,0,0,1,126.53,96Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M98.86,22.12l-16-3.1h0l-6.14.81s0,0,0,.06l0,5.66A2.24,2.24,0,0,0,78,27.34l8.59,4.95a6.1,6.1,0,0,0,5.52.23L98,29.15a1.66,1.66,0,0,0,.94-1.38V22.18A.06.06,0,0,0,98.86,22.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M89.71,33.78a7.07,7.07,0,0,1-3.47-.87l-8.59-5A3,3,0,0,1,76,25.55V19.27l.66-.14,6.27-.82.15,0,16.54,3.2.05.64,0,5.59a2.3,2.3,0,0,1-1.29,2l-5.85,3.37A5.51,5.51,0,0,1,89.71,33.78ZM77.36,20.46v5.08c0,.39.37.83,1,1.19l8.58,4.95a5.45,5.45,0,0,0,4.82.23l5.84-3.37c.27-.16.59-.41.59-.77V22.71l-15.37-3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M89.32,20.28V33.06a5.16,5.16,0,0,0,2.79-.53L98,29.15a1.65,1.65,0,0,0,.94-1.37v-5.6a.05.05,0,0,0,0-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M89.72,33.78h-.44l-.67,0V19.42l11,2.12.05.64,0,5.6a2.28,2.28,0,0,1-1.29,2l-5.85,3.38A5.5,5.5,0,0,1,89.72,33.78ZM90,21.14V32.36a3.93,3.93,0,0,0,1.73-.44l5.84-3.38a1,1,0,0,0,.59-.77V22.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M98,23.45l-5.85,3.37a6.1,6.1,0,0,1-5.52-.23L78,21.64c-1.63-.95-1.81-2.38-.39-3.19l5.84-3.38A6.17,6.17,0,0,1,89,15.3l8.59,5C99.2,21.2,99.37,22.63,98,23.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M89.71,28.08a7.07,7.07,0,0,1-3.47-.88l-8.59-4.95A3,3,0,0,1,76,19.83a2.3,2.3,0,0,1,1.3-2l5.85-3.38a6.84,6.84,0,0,1,6.23.23l8.58,5a2.93,2.93,0,0,1,1.71,2.41,2.34,2.34,0,0,1-1.31,2l-5.85,3.37A5.51,5.51,0,0,1,89.71,28.08ZM85.84,15.23a4.23,4.23,0,0,0-2,.45L78,19.06c-.23.13-.6.4-.6.77s.37.83,1,1.19l8.58,5a5.45,5.45,0,0,0,4.82.23l5.84-3.37c.23-.13.61-.41.61-.78s-.38-.83-1-1.19l-8.59-5A5.75,5.75,0,0,0,85.84,15.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M98,12.2A.72.72,0,0,0,98,12a13.5,13.5,0,0,0-6-10.19l-.44-.23A11.76,11.76,0,0,0,90,1.07,11.62,11.62,0,0,0,80.7,2.73a.61.61,0,0,0-.17.81l11,18.18a.61.61,0,0,0,.87.18,13.16,13.16,0,0,0,5.1-7.19A11.25,11.25,0,0,0,98,12.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M92.11,22.72a1.24,1.24,0,0,1-.27,0,1.31,1.31,0,0,1-.86-.61l-11-18.17a1.29,1.29,0,0,1,.38-1.76A12.18,12.18,0,0,1,90.14.39a12.31,12.31,0,0,1,1.62.55s.36.18.51.27a14.24,14.24,0,0,1,6.4,10.72,2.41,2.41,0,0,1,0,.31h0A11.83,11.83,0,0,1,98.2,15a13.89,13.89,0,0,1-5.33,7.47A1.3,1.3,0,0,1,92.11,22.72ZM81.19,3.26l10.94,18a12.55,12.55,0,0,0,4.74-6.74,11,11,0,0,0,.41-2.34l0-.14a12.69,12.69,0,0,0-5.69-9.61l-.41-.21a9,9,0,0,0-1.33-.45A10.83,10.83,0,0,0,81.19,3.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M90.94,12.85l-3.16,2.06v.55l3.8,6.26a.61.61,0,0,0,.87.18,13.16,13.16,0,0,0,5.1-7.19A11.25,11.25,0,0,0,98,12.2.72.72,0,0,0,98,12a6.86,6.86,0,0,0-.53-2.13,27.13,27.13,0,0,1-3.76,3.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M92.11,22.72a1.24,1.24,0,0,1-.27,0,1.31,1.31,0,0,1-.86-.61l-3.9-6.42V14.53l3.75-2.45,2.69.77a24.21,24.21,0,0,0,3.34-3.37l.82-1.18.43,1.37c.08.25.15.44.21.62a4.76,4.76,0,0,1,.35,1.64,2.41,2.41,0,0,1,0,.31A11.83,11.83,0,0,1,98.2,15a13.89,13.89,0,0,1-5.33,7.47A1.3,1.3,0,0,1,92.11,22.72ZM88.5,15.29l3.63,6a12.55,12.55,0,0,0,4.74-6.74,11,11,0,0,0,.41-2.34l0-.14a3.35,3.35,0,0,0-.09-.72,35,35,0,0,1-3,2.86l-.29.24-2.79-.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M91.92,1.82l-.44-.23A11.76,11.76,0,0,0,90,1.07a11.56,11.56,0,0,0-9.09,1.55.8.8,0,0,0-.24,1.08L83.83,9a.19.19,0,0,0,.1.08l2.76,1a.22.22,0,0,0,.23-.06l1.52-2V8l1.07-1.83.06-.06c.28-.18,2.06-1.35,4.14-2.54a.2.2,0,0,0,0-.32A10.18,10.18,0,0,0,91.92,1.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M86.76,10.8a.85.85,0,0,1-.31-.06l-2.76-1a.88.88,0,0,1-.46-.37L80,4.07a1.48,1.48,0,0,1,.46-2A11.9,11.9,0,0,1,91.76.94s.36.18.51.27a10.82,10.82,0,0,1,2,1.52.92.92,0,0,1,.27.76.88.88,0,0,1-.45.68c-1.84,1-3.42,2.07-4,2.45l-1,1.73-1.58,2.09A.91.91,0,0,1,86.76,10.8ZM84.34,8.45l2.24.84,1.29-1.7L89,5.66l.19-.15c.43-.28,1.85-1.2,3.58-2.21a8.57,8.57,0,0,0-1.2-.87h0l-.4-.21a9,9,0,0,0-1.33-.45,10.85,10.85,0,0,0-8.57,1.45.09.09,0,0,0,0,.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M94.19,17.16c0,2.62-1,4.43-2.47,5.23s-5.06.14-7.18-1.09a12.7,12.7,0,0,1-6.6-11.62c0-2,.92-5.3,1.89-6.26,1.45-1.43,3.78-1.56,6.41,0C90.63,5.91,94.19,12.08,94.19,17.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M89.92,23.42a12.56,12.56,0,0,1-5.73-1.51,13.4,13.4,0,0,1-7-12.23c0-2.13.93-5.62,2.1-6.77,1.73-1.71,4.45-1.76,7.25-.14,4.58,2.64,8.31,9.1,8.31,14.39,0,2.77-1,4.91-2.86,5.85A4.71,4.71,0,0,1,89.92,23.42ZM82.68,3a3.23,3.23,0,0,0-2.35.93c-.79.77-1.68,3.84-1.68,5.76a11.93,11.93,0,0,0,6.24,11c2.09,1.21,5.43,1.62,6.5,1.07,1.35-.7,2.1-2.34,2.1-4.6A16.85,16.85,0,0,0,85.88,4,6.6,6.6,0,0,0,82.68,3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M90.16,17.5C90.16,21.4,87.41,23,84,21a13.53,13.53,0,0,1-6.12-10.61c0-3.9,2.74-5.49,6.12-3.53A13.54,13.54,0,0,1,90.16,17.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M86.77,22.58a6.26,6.26,0,0,1-3.09-.93A14.37,14.37,0,0,1,77.2,10.42c0-2.15.76-3.77,2.15-4.57s3.17-.65,5,.42A14.34,14.34,0,0,1,90.86,17.5c0,2.15-.76,3.77-2.14,4.57A3.86,3.86,0,0,1,86.77,22.58ZM81.3,6.75a2.5,2.5,0,0,0-1.25.32c-.93.53-1.44,1.73-1.44,3.35a12.78,12.78,0,0,0,5.77,10c1.41.82,2.7,1,3.63.43s1.44-1.73,1.44-3.35a12.78,12.78,0,0,0-5.77-10A4.85,4.85,0,0,0,81.3,6.75Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 83.17,
    y: 16.33,
    width: 3.1,
    height: 1.41,
    transform: "translate(2.52 43.7) rotate(-29.34)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 81.53,
    y: 13.21,
    width: 5.14,
    height: 1.41,
    transform: "matrix(0.86, -0.5, 0.5, 0.86, 4.42, 44.22)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 81.73,
    y: 10.6,
    width: 2.45,
    height: 1.41,
    transform: "translate(4.77 41.26) rotate(-28.72)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M89.87,33.61l0-1.08a5.16,5.16,0,0,0,2-.47l4.49-2.6.54.94L92.38,33A6.24,6.24,0,0,1,89.87,33.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M162.75,58.88l-16-3.1h0l-6.13.81a.06.06,0,0,0-.05.06V62.3a2.23,2.23,0,0,0,1.34,1.79l8.58,5a6.11,6.11,0,0,0,5.52.23l5.85-3.37a1.65,1.65,0,0,0,.94-1.38V58.94A.07.07,0,0,0,162.75,58.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M153.59,70.54a7.07,7.07,0,0,1-3.47-.88l-8.59-5a3,3,0,0,1-1.69-2.4V56l.65-.15,6.31-.83.17,0,16.49,3.19.05.64,0,5.59a2.31,2.31,0,0,1-1.29,2l-5.84,3.37A5.55,5.55,0,0,1,153.59,70.54ZM141.24,57.22l0,5.08c0,.39.37.83,1,1.18l8.58,5a5.45,5.45,0,0,0,4.82.23l5.85-3.38a1,1,0,0,0,.58-.77v-5l-15.37-3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M153.2,57V69.82a5.16,5.16,0,0,0,2.79-.53l5.85-3.38a1.64,1.64,0,0,0,.94-1.38V58.94a0,0,0,0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M153.61,70.54l-.45,0-.66,0V56.18l10.95,2.12.05.64,0,5.6a2.3,2.3,0,0,1-1.29,2l-5.84,3.38A5.55,5.55,0,0,1,153.61,70.54Zm.3-12.65V69.12a4.07,4.07,0,0,0,1.73-.44l5.85-3.38a1,1,0,0,0,.58-.77V59.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M161.84,60.2,156,63.58a6.14,6.14,0,0,1-5.52-.23l-8.58-5c-1.64-.94-1.82-2.37-.4-3.18l5.85-3.38a6.14,6.14,0,0,1,5.52.23l8.58,5C163.08,58,163.25,59.39,161.84,60.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M153.59,64.84a7.07,7.07,0,0,1-3.47-.88l-8.59-5a2.94,2.94,0,0,1-1.7-2.41,2.32,2.32,0,0,1,1.31-2L147,51.22a6.81,6.81,0,0,1,6.23.23l8.59,5a2.94,2.94,0,0,1,1.7,2.41,2.32,2.32,0,0,1-1.31,2l-5.84,3.37A5.66,5.66,0,0,1,153.59,64.84ZM149.73,52a4.13,4.13,0,0,0-2,.46l-5.85,3.38c-.22.13-.6.4-.6.77s.37.83,1,1.19l8.58,5a5.45,5.45,0,0,0,4.82.23l5.85-3.38c.22-.13.6-.4.6-.77s-.37-.83-1-1.19l-8.59-5A5.75,5.75,0,0,0,149.73,52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M161.87,49a1.13,1.13,0,0,0,0-.19,13.48,13.48,0,0,0-6-10.19l-.44-.23a11.22,11.22,0,0,0-1.52-.52,11.58,11.58,0,0,0-9.26,1.66.61.61,0,0,0-.17.81l11.06,18.18a.62.62,0,0,0,.87.18,13.3,13.3,0,0,0,5.1-7.19A11.87,11.87,0,0,0,161.87,49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M156,59.47l-.26,0a1.37,1.37,0,0,1-.87-.61L143.81,40.66a1.29,1.29,0,0,1,.38-1.75A12.18,12.18,0,0,1,154,37.15a10.71,10.71,0,0,1,1.64.56s.34.17.49.26a14.25,14.25,0,0,1,6.41,10.76h0a1.37,1.37,0,0,1,0,.27h0a12,12,0,0,1-.49,2.77,13.89,13.89,0,0,1-5.33,7.47A1.29,1.29,0,0,1,156,59.47ZM145.07,40,156,58a12.61,12.61,0,0,0,4.75-6.74,11.35,11.35,0,0,0,.4-2.34v0a12.77,12.77,0,0,0-5.71-9.7L155,39a10.09,10.09,0,0,0-1.33-.46A10.83,10.83,0,0,0,145.07,40Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M154.83,49.61l-3.16,2.06v.55l3.81,6.26a.62.62,0,0,0,.87.18,13.3,13.3,0,0,0,5.1-7.19,11.87,11.87,0,0,0,.43-2.51,1.13,1.13,0,0,0,0-.19,6.86,6.86,0,0,0-.53-2.13,27.87,27.87,0,0,1-3.75,3.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M156,59.47l-.26,0a1.37,1.37,0,0,1-.87-.61L151,52.42V51.28l3.75-2.44,2.69.77a23.67,23.67,0,0,0,3.34-3.37l.82-1.19.43,1.38.21.62a5.13,5.13,0,0,1,.36,1.68h0a1.37,1.37,0,0,1,0,.27,12.38,12.38,0,0,1-.49,2.77,13.89,13.89,0,0,1-5.33,7.47A1.29,1.29,0,0,1,156,59.47ZM152.38,52,156,58a12.61,12.61,0,0,0,4.75-6.74,11.66,11.66,0,0,0,.4-2.35l0-.14a3.25,3.25,0,0,0-.09-.71,35.2,35.2,0,0,1-3,2.86l-.29.24-2.79-.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M155.8,38.58l-.44-.23a11.22,11.22,0,0,0-1.52-.52,11.53,11.53,0,0,0-9.08,1.55.79.79,0,0,0-.25,1.08l3.21,5.27a.16.16,0,0,0,.1.08l2.75,1a.2.2,0,0,0,.23-.07l1.52-2v0l1.08-1.83a.13.13,0,0,1,.06-.07c.27-.18,2.05-1.34,4.13-2.53a.2.2,0,0,0,0-.32A9.35,9.35,0,0,0,155.8,38.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M150.64,47.56a.91.91,0,0,1-.32-.06l-2.75-1a.93.93,0,0,1-.46-.37l-3.2-5.27a1.49,1.49,0,0,1,.46-2A12.28,12.28,0,0,1,154,37.15a10.71,10.71,0,0,1,1.64.56s.34.17.49.26h0a10.39,10.39,0,0,1,2,1.52.87.87,0,0,1,.27.76.88.88,0,0,1-.45.68c-1.92,1.1-3.58,2.18-4,2.45l-1,1.73-1.58,2.09A.9.9,0,0,1,150.64,47.56Zm-2.41-2.35,2.24.84,1.29-1.71,1.12-1.92.2-.15c.07-.05,1.62-1.08,3.57-2.22a8.7,8.7,0,0,0-1.2-.86h0L155,39a10.09,10.09,0,0,0-1.33-.46A10.89,10.89,0,0,0,145.14,40a.09.09,0,0,0,0,.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M158.07,53.91c0,2.62-.95,4.44-2.47,5.23s-5,.15-7.18-1.08a12.7,12.7,0,0,1-6.6-11.62c0-2,.92-5.3,1.89-6.27,1.45-1.43,3.78-1.55,6.41,0C154.51,42.67,158.07,48.84,158.07,53.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M153.81,60.18a12.69,12.69,0,0,1-5.74-1.51,13.41,13.41,0,0,1-6.95-12.24c0-2.12.93-5.61,2.1-6.76,1.73-1.71,4.44-1.77,7.25-.15,4.58,2.65,8.31,9.11,8.31,14.4,0,2.77-1,4.91-2.85,5.85A4.77,4.77,0,0,1,153.81,60.18Zm-7.24-20.43a3.25,3.25,0,0,0-2.36.93c-.78.77-1.68,3.84-1.68,5.75a11.92,11.92,0,0,0,6.25,11c2.08,1.2,5.43,1.63,6.49,1.07,1.35-.7,2.1-2.34,2.1-4.6a16.82,16.82,0,0,0-7.6-13.17A6.49,6.49,0,0,0,146.57,39.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M154,54.25c0,3.91-2.74,5.49-6.13,3.54a13.53,13.53,0,0,1-6.12-10.61c0-3.91,2.74-5.49,6.12-3.54A13.55,13.55,0,0,1,154,54.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M150.65,59.34a6.31,6.31,0,0,1-3.09-.94,14.33,14.33,0,0,1-6.48-11.22c0-2.15.76-3.78,2.15-4.58s3.17-.64,5,.43a14.37,14.37,0,0,1,6.48,11.22c0,2.16-.77,3.78-2.15,4.58A3.86,3.86,0,0,1,150.65,59.34Zm-5.47-15.83a2.44,2.44,0,0,0-1.24.32c-.93.53-1.45,1.72-1.45,3.35a12.77,12.77,0,0,0,5.78,10c1.4.81,2.69,1,3.62.43s1.44-1.73,1.44-3.36a12.8,12.8,0,0,0-5.77-10A4.93,4.93,0,0,0,145.18,43.51Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 147.06,
    y: 53.09,
    width: 3.1,
    height: 1.41,
    transform: "translate(-7.3 79.72) rotate(-29.34)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 145.41,
    y: 49.97,
    width: 5.14,
    height: 1.41,
    transform: "matrix(0.86, -0.5, 0.5, 0.86, -5.39, 81.39)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 145.61,
    y: 47.36,
    width: 2.45,
    height: 1.41,
    transform: "translate(-5.07 76.27) rotate(-28.64)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M153.75,70.37l0-1.08a5.16,5.16,0,0,0,2-.47l4.49-2.6.55.94-4.5,2.6A6.21,6.21,0,0,1,153.75,70.37Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgServerError);
export default __webpack_public_path__ + "static/media/server-error.80977dca1744abf2be4276e60dd251c3.svg";
export { ForwardRef as ReactComponent };